const gmt = localStorage.getItem('gmt') || ''

//全局时区变量
export default {
  state: {
    gmt: Number(gmt || -Math.floor(new Date().getTimezoneOffset() / 60))
  },

  mutations: {
    //保存时区
    saveGmt(state, value) {
      state.gmt = value
      localStorage.setItem('gmt', value)
    }
  }
}
